import React, { useEffect, useState } from "react";
import { Box, Button, Grid, TextField, ThemeProvider } from "@mui/material";
import useFilterHandler from "../../../../hooks/useFilterHandler";
import { useQuery } from "react-query";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { HabilitarDiagnosticoService } from "../services";
import useRenderFormStore from "../../stores/useRenderFormStore";
import { BaSeDialogContext } from "@base/react";
import { FaEllipsisV } from "react-icons/fa";
import theme from "../../../../mui-theme";
import styles from "./styles.module.scss";
import { handleModalStatus } from "../../../../../utils/handleModalStatus";
import TextAreaInput from "../../../../../components/TextAreaInput";
import Spinner from "react-spinner-material";
import { RiPencilLine } from "react-icons/ri";
import SETextEditor from "../../../../components/SETextEditor";
import { HabilitarDiagnosticoInterface } from "../../../../interfaces";
import { useHistory } from "react-router";

const EditFormulario = () => {
  const history = useHistory();
  const temaColumns = [
    {
      id: "ordenacaoTema",
      label: "Ordem",
      width: "20%",
    },
    {
      id: "descAreaTematicaDiagnostico",
      label: "Temas",
      width: "80%",
    },
  ];

  const questionsColumns = [
    {
      id: "ordenacao",
      label: "Ordem",
      width: "15%",
    },
    {
      id: "diagnosticoPerguntaDescricao",
      label: "Pergunta",
      width: "55%",
    },
    {
      id: "descAreaTematicaDiagnostico",
      label: "Tema",
      width: "15%",
    },
    {
      id: "descSubtemaDiagnostico",
      label: "Subtema",
      width: "15%",
    },
  ];

  const { formData } = useRenderFormStore();

  const [temaSelecionado, setTemaSelecionado] = useState<any>(null);
  const [temas, setTemas] = useState<any>([]);
  const [perguntas, setPerguntas] = useState<any>([]);
  const [expanded, setExpanded] = React.useState<any>([]);

  const { paginationFilters, bodyFilters } = useFilterHandler();

  const { showModal } = React.useContext(BaSeDialogContext);

  const { data: questionario, isLoading: isLoadingQuestionario } = useQuery({
    queryFn: () => HabilitarDiagnosticoService.findQuestionarios(formData?.id),
    queryKey: [
      "habilitarDiagnosticoQuestionario",
      paginationFilters,
      bodyFilters,
    ],
  });

  const handleExpand = (index: number) => {
    setExpanded((prevState: any) => {
      if (prevState.includes(index)) {
        return prevState.filter((item: any) => item !== index);
      } else {
        return [...prevState, index];
      }
    });
  };

  useEffect(() => {
    setExpanded([]);
  }, [temaSelecionado]);

  const handleLabelLevel = (nome: string) => {
    const letter = nome.charAt(0);
    const COLOR_OPTION = {
      B: "#CD5BE8",
      I: "#666BFD",
      A: "#0DBABA",
    };

    return (
      <div
        style={{
          //@ts-ignore
          color: COLOR_OPTION[letter],
        }}
      >
        {letter}
      </div>
    );
  };

  const goBack = () => {
    history.push(`/tabelas-de-controle/habilitar-no-app`);
  };

  const handleUpdateDiagnostico = (prop: HabilitarDiagnosticoInterface) => {
    HabilitarDiagnosticoService.update(prop)
      .then(() => {
        handleModalStatus({
          type: "success",
          msgOnSuccess: "Diagnóstico foi editado com sucesso.",
          // onCloseModal: handleGoHome,
          //@ts-ignore
          showModal,
        });
        goBack();
      })
      .catch((error) => {
        const errorMessage = error?.response?.data?.descricao;
        if (errorMessage) {
          handleModalStatus({
            type: "error",
            msgOnError: errorMessage,
            //@ts-ignore
            showModal,
          });
          return;
        }
        handleModalStatus({
          type: "error",
          msgOnError:
            "O Diagnóstico não foi editado. Aconteceu um erro ou o sistema está temporariamente fora do ar. Tente novamente mais tarde.",
          //@ts-ignore
          showModal,
        });
      })
      .finally(() => {});
  };

  const save = () => {
    if (temaSelecionado) {
      const subTemasOrdenados = temaSelecionado.subTemas.map((subTema: any) => {
        const perguntasOrdenadas = subTema.perguntas.map((p: any) => {
          const findOrder = perguntas.find(
            (item: any) =>
              item.diagnosticoPerguntaID === p.diagnosticoPerguntaID &&
              item.codSubtemaDiagnostico === subTema.codSubtemaDiagnostico
          );
          p.ordenacao = findOrder.ordenacao;
          return p;
        });
        return { ...subTema, perguntas: perguntasOrdenadas };
      });
      const temaToUpdate = temas.find(
        (t: any) =>
          t.codAreaTematicaDiagnostico ===
          temaSelecionado.codAreaTematicaDiagnostico
      );
      temaToUpdate.subTemas = subTemasOrdenados;
      setTemas(
        [
          ...temas.filter(
            (t: any) =>
              t.codAreaTematicaDiagnostico !==
              temaToUpdate.codAreaTematicaDiagnostico
          ),
          temaToUpdate,
        ].sort((a, b) => a.ordenacaoTema - b.ordenacaoTema)
      );
      setTemaSelecionado(null);
    } else {
      questionario.temas = temas;
      handleUpdateDiagnostico(questionario);
    }
  };

  const onSelectTema = (tema: any) => {
    setTemaSelecionado(tema);
    const listaDePerguntas: any = [];
    tema.subTemas.forEach((subTema: any) => {
      subTema.perguntas.forEach((pergunta: any, index: number) => {
        listaDePerguntas.push({
          ...pergunta,
          descSubtemaDiagnostico: subTema.descSubtemaDiagnostico,
          codSubtemaDiagnostico: subTema.codSubtemaDiagnostico,
        });
      });
    });
    listaDePerguntas.sort((a: any, b: any) => a.ordenacao - b.ordenacao);
    setPerguntas(listaDePerguntas);
  };

  const renderLevelHasExists = (item: any) => {
    const ordenarNiveis = (niveis: any) => {
      const ordemDesejada = ["Básico", "Intermediário", "Avançado"];
      niveis.sort((a: any, b: any) => {
        return ordemDesejada.indexOf(a.nome) - ordemDesejada.indexOf(b.nome);
      });
      return niveis;
    };

    return ordenarNiveis(item.niveis)?.map((nivel: any) => {
      return (
        <SETextEditor
          //@ts-ignore
          onChange={(value: any) => (nivel.descricao = value)}
          label={handleLabelLevel(nivel.nome)}
          notRequired
          showMaxLengthLabel
          value={nivel?.descricao}
          maxLength={2000}
          style={{ marginBottom: 16 }}
        />
      );
    });
  };

  const renderLevelHasNotExists = (item: any) => {
    item.niveis = [
      { id: null, nome: "Básico", descricao: null },
      { id: null, nome: "Intermediário", descricao: null },
      { id: null, nome: "Avançado", descricao: null },
    ];
    const ordenarNiveis = (niveis: any) => {
      const ordemDesejada = ["Básico", "Intermediário", "Avançado"];
      niveis.sort((a: any, b: any) => {
        return ordemDesejada.indexOf(a) - ordemDesejada.indexOf(b);
      });
      return niveis;
    };

    return ordenarNiveis(item?.niveis)?.map((nivel: any) => (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        {handleLabelLevel(nivel.nome)}
        <SETextEditor
          // @ts-ignore
          onChange={(value: any) => (nivel.descricao = value)}
          notRequired
          showMaxLengthLabel
          value={nivel?.descricao}
          maxLength={2000}
          style={{ marginBottom: 16 }}
        />
        {/* @ts-ignore */}
        <TextAreaInput
          onChange={(value: any) => (nivel.descricao = value)}
          height={"6rem"}
          notRequired={true}
          showMaxLengthLabel={true}
          value={nivel?.descricao}
          maxLength={2000}
        />
      </div>
    ));
  };

  const renderOrderTemas = () => {
    return (
      <DragDropContext onDragEnd={onDragEndTema}>
        <Droppable droppableId="table">
          {(provided) => (
            <div {...provided.droppableProps} ref={provided.innerRef}>
              <Box display="flex" flexDirection="row">
                {temaColumns.map((column, index) => {
                  return (
                    <div
                      key={index}
                      style={{
                        padding: "8px 16px",
                        backgroundColor: "#7B80FF",
                        borderRight:
                          index !== temaColumns.length - 1
                            ? "1px solid #FFFFFF"
                            : "none",
                        width: column.width,
                        fontFamily: "Mulish, sans-serif",
                        fontSize: 13,
                        fontWeight: "600",
                        borderTopLeftRadius: !index ? 4 : 0,
                        borderTopRightRadius:
                          index === temaColumns.length - 1 ? 4 : 0,
                      }}
                    >
                      {
                        <div className={styles.tableCellContainer}>
                          <p
                            className={styles.titleTable}
                            style={{ color: "#FFFFFF" }}
                          >
                            {column.label}
                          </p>
                        </div>
                      }
                    </div>
                  );
                })}
              </Box>
              {temas.map((row: any, index: number) => (
                <Draggable
                  key={row.ordenacaoTema}
                  draggableId={row.ordenacaoTema.toString()}
                  index={index}
                >
                  {(providedDragabble) => (
                    <div
                      ref={providedDragabble.innerRef}
                      {...providedDragabble.draggableProps}
                      {...providedDragabble.dragHandleProps}
                    >
                      <div className={styles.containerDraggable}>
                        {temaColumns.map((column, idx) => {
                          const { id } = column;
                          const value = row[id];

                          const isOrdenacao = Boolean(id === "ordenacaoTema");
                          return (
                            <div
                              key={id}
                              style={{
                                display: "flex",
                                justifyContent: "flex-start",
                                flexDirection: isOrdenacao ? "row" : "column",
                                alignItems: !isOrdenacao
                                  ? "flex-start"
                                  : "center",
                                color: "#555770",
                                fontFamily: "Mulish, sans-serif",
                                borderRight:
                                  idx !== temaColumns.length - 1
                                    ? "1px solid #EBEBF0"
                                    : 0,
                                borderBottom: "1px solid #ebebf0",
                                width: column.width,
                                padding: "8px 16px",
                                borderBottomLeftRadius:
                                  !idx && index === temas.length - 1 ? 4 : 0,
                                borderBottomRightRadius:
                                  idx === temaColumns.length - 1 &&
                                  index === temas.length - 1
                                    ? 4
                                    : 0,
                              }}
                            >
                              {isOrdenacao ? (
                                <>
                                  <FaEllipsisV
                                    color="#CECECE"
                                    style={{ width: 6, height: 18 }}
                                  />
                                  <FaEllipsisV
                                    color="#CECECE"
                                    style={{
                                      width: 6,
                                      height: 18,
                                      marginRight: 16,
                                    }}
                                  />
                                  {value}
                                </>
                              ) : (
                                <div className={styles.cursor}>
                                  <span onClick={() => onSelectTema(row)}>
                                    {value}
                                  </span>
                                  <Button
                                    style={{ minWidth: 0, marginLeft: 16 }}
                                    onClick={() => handleExpand(row.id)}
                                    variant="outlined"
                                    size="small"
                                    color="inherit"
                                  >
                                    <RiPencilLine size={20} color="#555770" />
                                  </Button>
                                </div>
                              )}
                            </div>
                          );
                        })}
                      </div>
                      {expanded.includes(row.id) && (
                        <div
                          style={{
                            padding: 16,
                            borderInline: "1px solid #EBEBF0",
                            borderBottom: "1px solid #ebebf0",
                          }}
                        >
                          {row?.niveis?.length
                            ? renderLevelHasExists(row)
                            : renderLevelHasNotExists(row)}
                        </div>
                      )}
                    </div>
                  )}
                </Draggable>
              ))}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    );
  };

  const renderOrderPerguntas = () => {
    return (
      <DragDropContext onDragEnd={onDragEndPerguntas}>
        <Droppable droppableId="table">
          {(provided) => (
            <div {...provided.droppableProps} ref={provided.innerRef}>
              <Box display="flex" flexDirection="row">
                {questionsColumns.map((column, index) => {
                  return (
                    <div
                      key={index}
                      style={{
                        padding: "8px 16px",
                        backgroundColor: "#7B80FF",
                        borderRight:
                          index !== questionsColumns.length - 1
                            ? "1px solid #FFFFFF"
                            : "1px solid #7B80FF",
                        width: column.width,
                        fontFamily: "Mulish, sans-serif",
                        fontSize: 13,
                        fontWeight: "600",
                        borderTopLeftRadius: !index ? 4 : 0,
                        borderTopRightRadius:
                          index === questionsColumns.length - 1 ? 4 : 0,
                      }}
                    >
                      {
                        <div className={styles.tableCellContainer}>
                          <p
                            className={styles.titleTable}
                            style={{ color: "#FFFFFF" }}
                          >
                            {column.label}
                          </p>
                        </div>
                      }
                    </div>
                  );
                })}
              </Box>
              {perguntas.map((item: any, index: number) => {
                return (
                  <Draggable
                    key={item.ordenacao}
                    draggableId={item.ordenacao.toString()}
                    index={index}
                  >
                    {(providedDragabble) => (
                      <div
                        ref={providedDragabble.innerRef}
                        {...providedDragabble.draggableProps}
                        {...providedDragabble.dragHandleProps}
                      >
                        <div className={styles.containerDraggable}>
                          {questionsColumns.map((column, idx) => {
                            const { id } = column;
                            const value = item[id];

                            const isOrdenacao = Boolean(id === "ordenacao");
                            const isTema = Boolean(
                              id === "descAreaTematicaDiagnostico"
                            );
                            const isPergunta = Boolean(
                              id === "diagnosticoPerguntaDescricao"
                            );

                            return (
                              <div
                                key={id}
                                style={{
                                  display: "flex",
                                  justifyContent: "flex-start",
                                  flexDirection: isOrdenacao ? "row" : "column",
                                  alignItems: !isOrdenacao
                                    ? "flex-start"
                                    : "center",
                                  color: "#555770",
                                  fontFamily: "Mulish, sans-serif",
                                  borderRight:
                                    idx !== questionsColumns.length - 1
                                      ? "1px solid #EBEBF0"
                                      : 0,
                                  borderBottom: "1px solid #EBEBF0",
                                  width: column.width,
                                  padding: "8px 16px",
                                  borderBottomLeftRadius:
                                    !idx && index === temas.length - 1 ? 4 : 0,
                                  borderBottomRightRadius:
                                    idx === questionsColumns.length - 1 &&
                                    index === perguntas.length - 1
                                      ? 4
                                      : 0,
                                }}
                              >
                                {isOrdenacao ? (
                                  <>
                                    <FaEllipsisV
                                      color="#CECECE"
                                      style={{ width: 6, height: 18 }}
                                    />
                                    <FaEllipsisV
                                      color="#CECECE"
                                      style={{
                                        width: 6,
                                        height: 18,
                                        marginRight: 16,
                                      }}
                                    />
                                    {value}
                                  </>
                                ) : isTema ? (
                                  <>
                                    {
                                      temaSelecionado.descAreaTematicaDiagnostico
                                    }
                                  </>
                                ) : isPergunta ? (
                                  <div className={styles.cursor}>
                                    <span onClick={() => handleExpand(item.id)}>
                                      {value}
                                    </span>
                                  </div>
                                ) : (
                                  value
                                )}
                              </div>
                            );
                          })}
                        </div>
                        {expanded.includes(item.id) && (
                          <div
                            style={{
                              padding: 16,
                              borderInline: "1px solid #EBEBF0",
                              borderBottom: "1px solid #ebebf0",
                            }}
                          >
                            {item?.respostas
                              ?.sort(
                                (a: any, b: any) => a.ordenacao - b.ordenacao
                              )
                              ?.map((resposta: any) => (
                                <p
                                  style={{
                                    color: "#646363",
                                    fontSize: "14px",
                                    lineHeight: "40px",
                                  }}
                                >
                                  {
                                    resposta.diagnosticoPerguntaRespostaDescricao
                                  }
                                </p>
                              ))}
                          </div>
                        )}
                      </div>
                    )}
                  </Draggable>
                );
              })}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    );
  };

  const onDragEndTema = (result: any) => {
    if (!result.destination) {
      return;
    }
    const novosItens = [...temas];
    const [itemArrastado] = novosItens.splice(result.source.index, 1);
    novosItens.splice(result.destination.index, 0, itemArrastado);

    novosItens.forEach((item, index) => {
      item.ordenacaoTema = index + 1;
    });

    setTemas(novosItens);
  };

  const onDragEndPerguntas = (result: any) => {
    if (!result.destination) {
      return;
    }
    const { source, destination } = result;

    const items = Array.from(perguntas);
    const [reorderedItem] = items.splice(source.index, 1);
    items.splice(destination.index, 0, reorderedItem);
    const newItems = items.map((item: any, index) => {
      return { ...item, ordenacao: index + 1 };
    });
    setPerguntas(newItems);
  };

  useEffect(() => {
    if (questionario) {
      const temas = [...questionario?.temas];
      temas.sort((a, b) => a.ordenacaoTema - b.ordenacaoTema);
      setTemas(temas);
    }
    // https://github.com/facebook/create-react-app/issues/6880
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questionario]);

  return (
    <ThemeProvider theme={theme}>
      <Grid item>
        <Grid container>
          <Grid item xs={12}>
            <Grid container spacing={2} my={2}>
              <Grid item md={5}>
                <TextField
                  label="Nome do diagnóstico"
                  disabled
                  fullWidth
                  value={questionario?.nome}
                />
              </Grid>
              <Grid item md={5}>
                {!!temaSelecionado && (
                  <TextField
                    label="Tema"
                    disabled
                    fullWidth
                    value={temaSelecionado?.descAreaTematicaDiagnostico}
                  />
                )}
              </Grid>
              <Grid item md={2}>
                <Button
                  fullWidth
                  style={{
                    backgroundColor: "#7B80FF",
                    fontFamily: "Mulish, sans-serif",
                    fontSize: "12px",
                    height: "-webkit-fill-available",
                  }}
                  variant="contained"
                  onClick={save}
                >
                  Salvar
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          {isLoadingQuestionario ? (
            <Grid
              container
              item
              alignItems={"center"}
              justifyContent={"center"}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Spinner
                  radius={80}
                  color={"#0061C6"}
                  stroke={2}
                  visible={true}
                />
                <p>Carregando...</p>
              </div>
            </Grid>
          ) : !!temaSelecionado ? (
            renderOrderPerguntas()
          ) : (
            renderOrderTemas()
          )}
        </Grid>

        <Grid
          item
          display="flex"
          justifyContent="flex-end"
          marginTop={2}
          width="100%"
        >
          <Button
            style={{
              borderColor: "#7B80FF",
              color: "#7B80FF",
              fontFamily: "Mulish, sans-serif",
              fontSize: "12px",
            }}
            variant="outlined"
            onClick={goBack}
          >
            Cancelar
          </Button>
        </Grid>
      </Grid>
    </ThemeProvider>
  );
};

export default EditFormulario;
